import authStorageService from '../../services/auth/auth-storage.service.js';
// Simple auth module that provides a loggedIn getter
export const state = () => ({})

export const getters = {
  loggedIn(state) {
    // Check if user is logged in by checking localStorage
    const accessToken = authStorageService.getAccessToken()
    const user = authStorageService.getUser()
    return !!(accessToken && user)
  }
}

export const actions = {}

export const mutations = {}
